import { KeyboardEvent, MouseEvent } from 'react';

export const preventDefault =
  (c: (e: MouseEvent | KeyboardEvent) => void, s?: boolean) =>
  (e: MouseEvent | KeyboardEvent) => {
    e.preventDefault();

    if (s) {
      e.stopPropagation();
    }

    c(e);
  };
